



































import { Component, Vue } from 'vue-property-decorator'
import Theme from '@/styles/Theme'
import { getModule } from 'vuex-module-decorators'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'

@Component

export default class ComponenteModalRecebimentoFiltro extends Vue {
  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get getModalFiltro() {
    return this.getRecebimentoStore.modalRecebimento.filtro
  }

  set getModalFiltro(value: boolean) {
    this.getRecebimentoStore.setModalRecebimentoFiltro(value)
    if (value) {
      this.clearRange()
    }
  }

  getTheme() {
    return Theme
  }

  async clearFilter() {
    this.getRecebimentoStore.clearFilter()
    const item: any = this.$refs.recebimentoFiltro
    item.clearFieldText()
    await this.clearRange()
  }

  async clearRange() {
    const item: any = this.$refs.recebimentoFiltro
    await item.clearRange()
    const itens: any = this.$refs.recebimentoFiltro
    await itens.loadRecebimentoItens()
  }

  async clearDate() {
    const item: any = this.$refs.recebimentoFiltro
    await item.clearRange()
  }

  btnConfirmar() {
    this.getModalFiltro = false
  }
}
